import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const SyntheticAIcon = createIcon(
  'SyntheticA',
  <path d="M8,20 L12,20 C12,21.1 11.1,22 10,22 C8.9,22 8,21.1 8,20 Z M12,9 C12,11.61 13.67,13.83 16,14.66 L16,17 L17,17 C17.55,17 18,17.45 18,18 L18,18 C18,18.55 17.55,19 17,19 L3,19 C2.45,19 2,18.55 2,18 L2,18 C2,17.45 2.45,17 3,17 L4,17 L4,10 C4,7.21 5.91,4.86 8.5,4.2 L8.5,3.5 C8.5,2.67 9.17,2 10,2 C10.83,2 11.5,2.67 11.5,3.5 L11.5,4.2 C12.21,4.38 12.86,4.69 13.45,5.1 C12.54,6.14 12,7.51 12,9 Z M21,8 L19,8 L19,6 C19,5.45 18.55,5 18,5 L18,5 C17.45,5 17,5.45 17,6 L17,8 L15,8 C14.45,8 14,8.45 14,9 L14,9 C14,9.55 14.45,10 15,10 L17,10 L17,12 C17,12.55 17.45,13 18,13 L18,13 C18.55,13 19,12.55 19,12 L19,10 L21,10 C21.55,10 22,9.55 22,9 L22,9 C22,8.45 21.55,8 21,8 Z" />
);

export default SyntheticAIcon;
